const getVideoDuration = (file) =>
  new Promise((resolve) => {
    if (!file.type.startsWith('video/')) {
      resolve(undefined);
      return;
    }
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      resolve(video.duration);
    };
    video.onerror = () => {
      window.URL.revokeObjectURL(video.src);
      resolve(undefined);
    };
    video.src = window.URL.createObjectURL(file);
  });

export default getVideoDuration;
